export const achtergrondInfoKoolstof = () => (
  <>
    <div>
      <p>
        In dit onderdeel ziet u de gegevens zoals ze voor uw bedrijf berekend
        zijn als input voor de berekening van CO2-emissies uit de bodem. <br />
        De manier waarop deze berekend zijn is afhankelijk van verschillende
        factoren:
      </p>
      <ul>
        <li>
          Heeft u op de pagina Overzicht de knop "Gebruik perceels- en
          bodemanalyse informatie voor de bepaling van CO2-emissies uit de
          bodem." aangezet?
          <ul>
            <li>
              Zo nee; dan wordt gerekend op basis van de postcode van uw bedrijf
            </li>
            <li>
              Zo ja: zijn uw percelen opgehaald bij RVO en uw bodemanalyses bij
              uw laboratorium?
              <ul>
                <li>
                  Zo nee: dan wordt gerekend op basis van de postcode van uw
                  bedrijf
                </li>
                <li>
                  Zo ja: gaat het volgens de mestwetgeving om zand- of
                  kleipercelen?
                  <ul>
                    <li>
                      Bestaat het perceel voor minder dan de helft uit moerige
                      grond?
                      <ul>
                        <li>
                          Is er een bodemanalyse met resultaten voor organische
                          stof, SOC, C/N van het perceel?
                          <ul>
                            <li>Zo ja, dan worden deze resultaten gebruikt</li>
                            <li>
                              Zo nee, dan worden deze waarden bepaald op basis
                              van de locatie van het perceel
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li>
                      Bestaat het perceel voor meer dan de helft uit moerige
                      grond?
                      <ul>
                        <li>
                          Het perceel valt onder organische bodems; de
                          CO2-emissie wordt berekend op basis van de locatie van
                          het perceel
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Gaat het volgens de mestwetgeving om Veenpercelen?
                      <ul>
                        <li>
                          Het perceel valt onder organische bodems; de
                          CO2-emissie wordt berekend op basis van de locatie van
                          het perceel
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </>
);
